<template>
  <div class="padding">
    <div class="flex align-center justify-between margin-bottom">
      <div class="flex align-center">
        <el-input
          placeholder="请输入企业全称"
          v-model="searchName"
          style="width: 180px"
        ></el-input>
        <el-select
          v-model="conversion"
          placeholder="请选择转化情况"
          class="margin-left-sm"
          style="width: 180px"
        >
          <el-option
            v-for="item in conversionList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button type="primary" class="margin-left-sm" @click="search"
          >搜索</el-button
        >
      </div>
      <div class="flex align-center" v-if="user.user_role === 1">
        <el-button type="primary" class="margin-left-sm" @click="addPrepare"
          >添加</el-button
        >
        <el-button type="primary" class="margin-left-sm" @click="editPrepare"
          >编辑</el-button
        >
        <el-button type="danger" class="margin-left-sm" @click="delPrepare"
          >删除</el-button
        >
      </div>
      <div class="flex align-center" v-if="user.user_role === 1">
        <el-link
          :href="showhost + '/static/file/new/入会邀请函.xlsx'"
          target="_blank"
          :underline="false"
          ><el-button
            icon="el-icon-download"
            type="warning"
            class="margin-left-sm"
            @click="search"
            >下载模版</el-button
          ></el-link
        >

        <el-upload
          ref="upload1"
          :action="udhost + '/api/Operation/operation_int'"
          :name="'file'"
          :data="fileData"
          :show-file-list="false"
          :on-exceed="handleExceed"
          :on-success="handleAvatarSuccess"
          class="margin-left-sm"
        >
          <el-button icon="el-icon-upload2" type="warning">数据导入</el-button>
        </el-upload>

        <el-link
          :href="udhost + '/api/Operation/export_prepare?name=' + searchName + '&type=' + conversion"
          target="_blank"
          :underline="false"
        >
          <el-button
            icon="el-icon-s-order"
            type="warning"
            class="margin-left-sm"
            @click="search"
            >信息导出</el-button
          ></el-link
        >
      </div>
    </div>

    <el-table
      :data="tableData"
      ref="multipleTable"
      header-row-class-name="table-header"
      row-class-name="table-row"
      alig="center"
      tooltip-effect="dark"
      border
      @selection-change="handleSelectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column type="" label="序号" width="80">
        <template slot-scope="scope">
          {{ (page - 1) * 10 + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column width="200px" prop="issue_date" label="发函日期">
      </el-table-column>
      <el-table-column width="200px" prop="company_name" label="企业全称">
      </el-table-column>
      <el-table-column prop="introducer_name" width="200px" label="入会介绍人">
      </el-table-column>
      <el-table-column
        width="150px"
        prop="unit_contact"
        label="单位联系人"
      >
      </el-table-column>

      <el-table-column prop="unit_phone" width="150px" label="联系人电话">
      </el-table-column>
      <el-table-column width="150px" label="分类">
        <template slot-scope="scope">
          {{ scope.row.member_type }}
        </template>
      </el-table-column>
      <el-table-column width="150px" prop="member_type" label="进程">
        <template slot-scope="scope">
          {{ scope.row.process }}
        </template>
      </el-table-column>
      <el-table-column width="150px" prop="certificate_num" label="证书编号">
      </el-table-column>
      <el-table-column width="150px" prop="bussess_scope" label="业务范围">
      </el-table-column>
      <el-table-column prop="valid_time" width="200px" label="到期时间">
      </el-table-column>
      <el-table-column width="150px" prop="amount_fee" label="会费全额">
      </el-table-column>
    </el-table>
    <div class="flex align-center justify-between padding-top-sm">
      <span>共{{ total }}条数据</span>
      <el-pagination
        v-if="tableData.length > 0"
        background
        @current-change="getList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { SHOWHOST, UDHOST } from '@/config/index'
import { listPrepare, prepareDel } from "@/api/admin";
import { conversionList } from "@/utils/utils";
export default {
  name: "invitation",
  data () {
    return {
      searchName: '',
      conversion: '',
      conversionList: conversionList,
      page: 1,
      limit: 10,
      total: 0,
      tableData: [],
      multipleSelection: [],

    }
  },
  computed: {
    udhost () {
      return UDHOST
    },
    showhost () {
      return SHOWHOST
    },
    fileData () {
      return {
        // token: this.user.token
      };
    },
    user () {
      return this.$store.state.user
    },
  },
  created () {
    this.getList()
  },
  components: {},
  methods: {
    // 上传失败
    handleExceed () {
      this.$message.error('上传失败，请重新上传')
    },
    //  上传成功
    handleAvatarSuccess (res) {
      if (res.status === 200) {
        this.$message.success(res.msg)
        this.page = 1
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    //  删除
    async delPrepare () {
      if (this.multipleSelection.length === 0) return this.$message.info('请选择至少一个会员')
      let _arr = []
      this.multipleSelection.map(item => {
        _arr.push(item.id)
      })
      let _state = await prepareDel(_arr.join(','))
      if (_state.status === 200) {
        this.$message.success('操作成功')
      } else {
        this.$message.error(_state.msg)
      }
      this.getList()
      this.multipleSelection = []
    },
    //  编辑
    editPrepare () {
      if (this.multipleSelection.length > 1 || this.multipleSelection.length === 0) return this.$message.info('请选择一个会员操作')
      this.$router.push('/admin/prepareEdit/' + this.multipleSelection[0].id)
    },
    //  添加
    addPrepare () {
      this.$router.push('/admin/prepareEdit/' + 0)
    },
    //  表格选择
    handleSelectionChange (val) {
      console.log(val)
      this.multipleSelection = val;
    },
    //  搜索
    search () {
      this.page = 1
      this.getList()
    },
    //  获取列表
    async getList () {
      let _list = await listPrepare(this.searchName, this.conversion, 1, this.page, this.limit)
      this.tableData = _list.data.data
      this.total = _list.data.total

    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
</style>